import React, { useState, useEffect, useContext } from "react";
import { Parser } from 'html-to-react'
import Typography from "@mui/material/Typography";

export const Intro = (props) => {

    return (
        <>
            {props.cultureCode === "en-us" &&
                <div className="container-fluid pt-5" id="Intro">
                    <div className="row pt-5">
                        <div className="col-lg-6 py-5 left">
                            <div className="row text-lg-end py-5 pe-lg-5">
                                <div className="col-12 pb-5">
                                    <h1 className="h1 d-none d-lg-block">Further than</h1>
                                    <h1 className="h1 d-block d-lg-none text-center">Further than you can sea</h1>
                                </div>
                                <div className="col-12 d-none d-lg-block">
                                    <img src="/images/Infynito80/shape.jpg" className="w-75" alt="" />
                                </div>
                                <div className="col-12 text-center d-block d-lg-none">
                                    <img src="/images/Infynito80/shape.jpg" className="w-75" alt="" />
                                </div>
                                <div className="col-12 mt-5">
                                    <p className="intro-design">Exterior design</p>
                                    <p className="intro-architect">Filippo Salvetti</p>
                                    <p className="intro-design">Interior design</p>
                                    <p className="intro-architect">IDEAEITALIA</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 py-5 right">
                            <div className="row py-5 ps-lg-5">
                                <div className="col-lg-6">
                                    <h1 className="h1 text-white d-none d-lg-block">you can sea</h1>
                                </div>
                                <div className="col-12 mt-5">
                                    <p className="text-white text-intro">&ldquo;We have given life to the second model of the INFYNITO range with the aim of keeping the range’s unique unmatched characteristics unaltered throughout the design process, while at the same time adding new features that make the model perfect for its different size.&rdquo;</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {props.cultureCode === "it-it" &&
                <div className="container-fluid pt-5" id="Intro">
                    <div className="row pt-5">
                        <div className="col-lg-6 py-5 left">
                            <div className="row text-lg-end py-5 pe-lg-5">
                                <div className="col-12 pb-5">
                                    <h1 className="h1 d-none d-lg-block">Further than</h1>
                                    <h1 className="h1 d-block d-lg-none text-center">Further than you can sea</h1>
                                </div>
                                <div className="col-12 d-none d-lg-block">
                                    <img src="/images/Infynito80/shape.jpg" className="w-75" alt="" />
                                </div>
                                <div className="col-12 text-center d-block d-lg-none">
                                    <img src="/images/Infynito80/shape.jpg" className="w-75" alt="" />
                                </div>
                                <div className="col-12 mt-5">
                                    <p className="intro-design">Exterior design</p>
                                    <p className="intro-architect">Filippo Salvetti</p>
                                    <p className="intro-design">Interior design</p>
                                    <p className="intro-architect">IDEAEITALIA</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 py-5 right">
                            <div className="row py-5 ps-lg-5">
                                <div className="col-lg-6">
                                    <h1 className="h1 text-white d-none d-lg-block">you can sea</h1>
                                </div>
                                <div className="col-12 mt-5">
                                    <p className="text-white text-intro">&ldquo;Abbiamo dato vita al secondo modello della gamma INFYNITO, con l’obiettivo di mantenerne inalterate nella progettazione alcune delle caratteristiche uniche e inimitabili, aggiungendone al tempo stesso di nuove, perfette per un progetto della sua metratura.&rdquo;</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );

};

export default Intro;